import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Button, Grid, Stack, TextField,  FormControl,InputLabel,Select,MenuItem } from "@mui/material";
import { orderUpdate, updateEntry, updatePurchaseEntry } from "./httpCalls";
import { updatePurchaseOrder } from "./httpCalls";
import { useHistory } from "react-router-dom";
import { convertToQty } from "../../utils/convertToQty";
import DefaultRepository from "../../Repository/DefaultRepository";
import PurchaseRepository from "../../Repository/PurchaseRepository";
import LedgersRepository from "../../Repository/LedgersRepository";
import { useDispatch } from "react-redux";
import { SideRow, TableHead, TableRow, TotalContainer } from "./styles";
import { UpdatePurchasePrint } from "./UpdatePurchasePrint";
import { Toast } from "../components/Toast";
import Loader from "../components/Loader";
import Repo from "../../Repository/Repo";
import {updateEntryDetails,fetchLedger }from "./httpCalls"
function UpdateOrder(props) {
  const {
    order,
    date,
    user,
    selectedToSale,
    selectedVendor,
    selectedLedger,
    ledger_detail,
  } = props.location.state;
console.log(props,"props")
console.log(order,"order")

console.log("sec",props?.location?.state?.order?.paid)

const userName = localStorage.getItem("username");
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState({
    modal: false,
    items: [],
    Total: 0,
    discount: 0,
    paid:props?.location?.state?.order?.paid || 0,
    total: 0,
    bill: true,
    remaining: 0,
    user: "",
    date: "",
    returnQuantity: "",
    purchase: {},
    loading: false,
    printLoading: false,
  });
  console.log('state', state.paid)
  console.log('itemsss', state.items)


  useEffect(() => {
    setState((prev) => ({
      ...prev,
      items: selectedToSale,
      purchase: order,
      remaining: order?.remaining,
    }));
  }, []);

  
  const getOrders = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    return await PurchaseRepository.purchasesModel({
      request: {
        method: "getPurchases",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    
    // console.log("data:", data);
    // setState((prev) => ({
    //   ...prev,
    //   loading: false,
    //   data: data.response.data.purchases[0],
    // }));

   
  };
  const updateItem = (items) => {
    items.forEach(async (item) => {
      let qty = item.returnQuantity ? parseInt(item.returnQuantity) : item.newQuantity;
      console.log('itemmmm', item)
      console.log('qtyy',  qty)

      let { data } = await DefaultRepository.defaultModel({
        request: {
          method: "getItem",
          data: {
            _id: item._id,
          },
        },
      });
      let latest = data.response.data.item;
      const field = latest.weight ? "weight" : "quantity";
      console.log("latestweight", field)
      console.log("weight", latest.weight)
      console.log("weight", latest.quantity)


      await DefaultRepository.defaultModel({
        request: {
          method: "updateItem",
          data: {
            item: {
              ...latest,
              [field]: parseInt(latest.weight ? latest.weight : latest.quantity) - qty,
            },
            action: "Returned",
            user: data.response.data.user,
          },
        },
      });
    });
  };

  const paymentCashBankHandler = async(id)=> {
    console.log('id', id)

    let method = props?.location?.state?.order?.purchaseMode == "Cash" ? "paymentyByCashInHand" : "paymentByBank"
    const currentDate = new Date();
  
    // Extract day, month, and year
    const day = String(currentDate.getDate()).padStart(2, '0'); // Ensures two digits
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = currentDate.getFullYear();
    
    // Format the date as dd-mm-yyyy
    const formattedDate = `${day}-${month}-${year}`;
    
    console.log(formattedDate);
    let { data } = await Repo.banks({
      request: {
      method: method,
      data: {
          company_code:  localStorage.getItem("companyCode"),
          ledgerId: selectedLedger,
          credit:0,
          debit:  Number(state.paid),
          paymentId: id,
          from: props?.location?.state?.order?.purchaseMode == "Cash" ? "cashInHand" :  userName,
          to:  props?.location?.state?.ledger_detail?.name || "",
          description:"",
          bankId:props?.location?.state?.order?.bankId,
          date:formattedDate
      }
    }
    });
 
    console.log('dataa', data)
  }
  const totalPrice = () => {
    let Total = 0;
    let remaining = 0;
    state.items.map((item) => {
      let itemPrice = item.newPrice ? item.newPrice : item.companyPrice;
      let qty = item.newQuantity ? item.newQuantity : 1;
      if (item.purchased_quantity) {
        Total +=
          parseFloat(qty * itemPrice) -
          parseInt(item?.purchased_quantity * itemPrice);
      } else {
        Total += parseFloat(qty * itemPrice);
      }
    });
    remaining = Total - state?.paid
    // if(props.location.state.order.paid) {
    //   remaining = Total  -(Number(state?.paid) + Number(props.location.state.order.paid))

    // } else {
    //   remaining = Total  - state?.paid

    // }
    // if (order.remaining) {
    //   remaining = order.remaining;
    // } else {
    //   remaining = 0;
    // }
    return { Total, remaining };
  };
  const handleInput = (e, index, item) => {
  
    let { value, name } = e.target;
    let qty;
    if(name !== "returnType") {
       qty = item.newQuantity ? parseInt(item.newQuantity) : 1;
    }
    if (name == "newQuantity") {
      let items = JSON.parse(JSON.stringify(state.items));
      items[index].newQuantity = value;
      console.log('itemss', items)
      setState((prev) => ({ ...prev, items }));
    } 
    
    else if(name == "returnType") {
      let items = JSON.parse(JSON.stringify(state.items));
      items[index].purchaseReturnType = value;
      setState((prev) => ({ ...prev, items }));
    } 
    else {
      if (value > qty) {
        Toast("info", "Return Qty less or equal to purchase Qty");
        return;
      }
      let items = JSON.parse(JSON.stringify(state.items));
      items[index].purchased_quantity = value;
      setState((prev) => ({ ...prev, items }));
    }
  };
  const handleSelect = (item) => {
    if (!item.purchased_quantity) {
      Toast("info", "Provide valid quantity");
      return;
    }
    let items = JSON.parse(JSON.stringify(state.items));
    let found = items.find((it) => it._id == item._id);
    if (found?.itemToReturn) {
      found.itemToReturn = false;
    } else {
      found.itemToReturn = true;
    }
    setState((prev) => ({ ...prev, items }));
  };
  const handleChange = (e) => {
    let { value } = e.target;
    setState((prev) => ({ ...prev, paid: value }));
  };
  const handleAddLedger = async () => {
    console.log('props.location.state.order.paid', props)

    console.log('props.location.state.order.paid', props.location.state.order.paid)
    console.log('state.paid', state.paid)
    console.log('totalPrice().Total', totalPrice().Total)

    if (selectedLedger) {
      if ((Number(props.location.state.order.paid) +Number(state?.paid) ) > totalPrice().Total) {
        Toast("warning", "Cant add more then remaining");
        return;
      } 
      // else if (totalPrice().remaining == 0) {
      //   Toast("warning", "Purchase Order already paid");
      //   return;
      // }
    }
    try {
      setState((prev) => ({ ...prev, printLoading: true }));
      let obj = {
        selectedVendor,
        ledger_detail,
        user,
        state: state,
        Total: totalPrice().Total,
        remaining: totalPrice().remaining,
      };
      UpdatePurchasePrint({ obj });
      let order = {
        props: props,
        paid: state.paid,
        Total: totalPrice().Total,
        items:state?.items
      };
    let data =  await orderUpdate(order);
    console.log("mode",props)
    let dataNew = await getOrders()
    console.log('data',dataNew.data.response.data.purchases[0]);
    // updatePurchaseEntry(order, totalReturn, rem, selectedLedger);
    const purchases = dataNew.data.response.data.purchases[0];
    // purchases.purchaseReturn = true;
    console.log("purchases", purchases)
  let sr = await fetchLedger(purchases)
  console.log('sr', sr)
   updateEntryDetails(purchases,history,sr)
  console.log('data', data.data.response.data.purchase)
     if(props?.location?.state?.order?.purchaseMode !== "Other") {
      await paymentCashBankHandler(data.data.response.data.purchase)

     }

      // if (selectedLedger) {
      //   await updateEntry(selectedLedger, state.paid,totalPrice().Total);
      // }
      setState((prev) => ({ ...prev, printLoading: false }));
      history.push("/inventory/admin/purchase-order/finalized");
    } catch (err) {
      console.log(err);
      Toast("error", err);
      setState((prev) => ({ ...prev, printLoading: false }));
    }
  };
  const handleReturnBill = async () => {
    console.log("ordersss", order)
    let value;
 
    await PurchaseRepository.purchasesModel({
      request: {
        method: "updatePurchase",
        data: {
          purchase: {
            ...order,
            purchase_return: true,
          },
        },
      },
    });

    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "getLedger",
        data: {
          _id: selectedLedger,
        },
      },
    });

    let ledger = data.response.data.ledger;

    let filtered = ledger.purchase
      .filter((item) => item.srNum != order.srNum)
      .map((item) => item);

    updatePurchaseEntry(order, order.total, order.remaining, selectedLedger);

    updateItem(state.items);
    Toast("success", "Purchase order fully returned");
    history.push("/inventory/admin/purchase-order/finalized");
  };
  const handleSelectedItems = async () => {
    setState((prev) => ({ ...prev, printLoading: true }));
    let returned_items = [];
    let keep_items = [];
    let retain = [];
    state.items.forEach((eachItem) => {
      if (eachItem.itemToReturn == true) {
        let { purchaseQty } = convertToQty("", eachItem, "purchaseQty");
        eachItem.purchased_quantity = purchaseQty;
        let copyItem = JSON.parse(JSON.stringify(eachItem));

        let finalQuantity = parseFloat(
          copyItem.newQuantity - copyItem.purchased_quantity
        );
        if (finalQuantity > 0) {
          let qty = copyItem.purchased_quantity;
          delete copyItem.salePrice;
          delete copyItem.purchased_quantity;
          delete copyItem.itemToReturn;
          returned_items.push({
            ...copyItem,
            returnQuantity: qty,
          });
          keep_items.push({ ...copyItem, newQuantity: finalQuantity });
        } else if (finalQuantity == 0) {
          delete copyItem.salePrice;
          delete copyItem.purchased_quantity;
          delete copyItem.itemToReturn;
          copyItem.returnQuantity = copyItem.returnedQuantity; // Assign the old value to the new field
          delete copyItem.returnedQuantity;
          returned_items.push(copyItem);

        }
      } else {
        delete eachItem.purchased_quantity;
        delete eachItem.salePrice;
        retain.push(eachItem);
      }
    });

    let finalRetain = JSON.parse(JSON.stringify([...retain, ...keep_items]));
    let totalReturn = returned_items.reduce(
      (prev, cur) =>
        prev + cur.newPrice
          ? parseInt(cur.newPrice * cur.newQuantity)
          : parseInt(cur.companyPrice * cur.newQuantity),
      0
    );
    //  let costPrice = copyItem

    // let total_paid = parseInt(order.paid) + parseInt(state.paid);
      let total_paid = parseInt(state.paid);

    let rem = 0;
    let afterReturn = order.remaining - totalReturn;
   
    if (afterReturn > 0) {
      rem = -totalReturn;
    } else {
      rem = 0;
      
    }

    let purchase = {
      ...props.location.state.order,
      items: finalRetain,
      // paid: total_paid,
      // total:totalPrice().Total,
      // paid: (totalPrice().Total - total_paid) < 0 ? totalPrice().Total :   (total_paid) ,
      
      remaining:(totalPrice().Total - total_paid) < 0 ? (0) : (totalPrice().Total - total_paid),
    };
    console.log('purcahse', purchase)
     purchase.paid =  Number(purchase.paid);


    

      await updatePurchaseOrder({ purchase, returned_items });
      let data = await getOrders()
     console.log('data',data.data.response.data.purchases[0]);
     // updatePurchaseEntry(order, totalReturn, rem, selectedLedger);
     const purchases = data.data.response.data.purchases[0];
     purchases.purchaseReturn = true;
     console.log("purchases", purchases)
   let sr = await fetchLedger(purchases)
   console.log('sr', sr)
    updateEntryDetails(purchases,history,sr)
     updateItem(returned_items);
    setState((prev) => ({ ...prev, printLoading: false }));
    history.push("/inventory/admin/purchase-order/finalized");
  };

  return (
    <Box sx={{ mt: { md: 3, xs: "50px" } }}>
      <Box>
        <TableHead className="none">
          <Typography sx={{ textAlign: "center" }}>#</Typography>
          <Typography>Item</Typography>
          <Typography>Purchased Qty</Typography>
          <Typography> Return Qty</Typography>
          <Typography> Unit Price</Typography>
          <Typography> Total Price</Typography>
        </TableHead>
        {state.items.map((item, index) => {
          let itemPrice = item.newPrice ? item.newPrice : item.companyPrice;
          let qty = item.newQuantity ? item.newQuantity : 1;

          return (
            <TableRow key={index}>
              <Typography variant="subtitle2" sx={{ textAlign: "center" }}>
                {index + 1}
              </Typography>
              <Typography variant="subtitle2">{item.name}</Typography>
              <TextField
                sx={{ height: "30px", width: "90%" }}
                size="small"
                variant="outlined"
                type="number"
                name="newQuantity"
                value={qty}
                onChange={(e) => handleInput(e, index, item)}
              />
              <TextField
                sx={{ height: "30px", width: "90%" }}
                size="small"
                variant="outlined"
                type="number"
                name="purchased_quantity"
                max={qty}
                min="0"
                value={item.purchased_quantity || ""}
                onChange={(e) => handleInput(e, index, item)}
              />
                 {/* {item?.box == true && (
                  <FormControl >
                    <InputLabel id="sale-type-label">Return Type</InputLabel>
                    <Select
                      labelId="sale-type-label"
                      id="sale-type"
                      name="returnType"
                      value={item?.returnType}
                      label="Return Type"
                      onChange={(e) =>  handleInput(e, index,item)}
                    >
                      <MenuItem value="box">
                        {item.saleLabel == "box" ? "By Box" : "By Ctn"}
                      </MenuItem>
                      <MenuItem value="pieces">
                        {item.saleLabel == "box" ? "By Pieces" : "By Box"}
                      </MenuItem>
                    </Select>
                  </FormControl>
                )} */}
              <Typography variant="subtitle2">{itemPrice}</Typography>
              <Typography variant="subtitle2">{itemPrice * qty}</Typography>
              <Button onClick={() => handleSelect(item)} className="none">
                {item?.itemToReturn == true ? "Unselect" : "Select"}
              </Button>
            </TableRow>
          );
        })}
      </Box>
      <Grid
        container
        spacing={1}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <TotalContainer item md={4} sm={6} xs={12}>
          <SideRow>
            <Typography variant="h6"> Total:</Typography>
            <TextField
              disabled
              sx={{ width: "100px" }}
              size="small"
              variant="outlined"
              value={totalPrice().Total || 0}
            />
          </SideRow>
          <hr></hr>
          <SideRow>
            <Typography variant="h6"> Remaining:</Typography>
            <TextField
              disabled
              sx={{ height: "30px", width: "100px" }}
              size="small"
              variant="outlined"
              value={totalPrice().remaining || 0}
            />
          </SideRow>
          {/* {order.addedToStock ? ( */}
          <>
            <hr></hr>
            <SideRow>
              <Typography variant="h6"> Pay:</Typography>
              <TextField
                sx={{ height: "30px", width: "100px" }}
                size="small"
                variant="outlined"
                type="number"
                max={parseInt(state.remaining)}
                disabled={state.remaining ? false : true}
                value={state.paid ? state.paid : props?.location?.state?.order?.paid }
                onChange={handleChange}
              />
            </SideRow>
          </>
          {/* ) : null} */}
          <hr />

          {/* {state.paid != "" && ( */}
            <Stack
              alignItems="center"
              justifyContent="center"
              margin="10px 0px"
            >
              {state.printLoading == true && (
                <Loader loading={state.printLoading} />
              )}
              {state.printLoading == false && (
                <Button
                  sx={{ backgroundColor: "#4EAF51", width: "150px" }}
                  variant="contained"
                  onClick={handleAddLedger}
                >
                  Update Purchase
                </Button>
              )}
            </Stack>
          {/* )} */}
          {/* {state.returnQuantity == "" && state.paid == "" && ( */}
          {state.returnQuantity == "" && (
            <Stack
              alignItems="center"
              justifyContent="center"
              margin="10px 0px"
            >
              <Button variant="contained" onClick={handleReturnBill}>
                Return Full Order
              </Button>
            </Stack>
          )}
          {state.items.find((foundItem) => foundItem.itemToReturn == true) && (
            <Stack
              alignItems="center"
              justifyContent="center"
              margin="10px 0px"
            >
              {state.printLoading == false && (
                <Button variant="contained" onClick={handleSelectedItems}>
                  Return Selected Items
                </Button>
              )}
            </Stack>
          )}
        </TotalContainer>
      </Grid>
    </Box>
  );
}

export default UpdateOrder;
